import { ComplianceCustomerResponse, CustomerListTableItem } from '@/api';
import { ComplianceCustomersData } from '@/redux/models';

const fetchCustomers = (
  response: ComplianceCustomerResponse,
): ComplianceCustomersData => {
  const {
    data: { items, total },
  } = response;

  let entries: CustomerListTableItem[] = [];

  if (Array.isArray(items) && items.length) {
    entries = items.map((item) => {
      const extras = item.extras;
      return {
        key: item.id,
        user: item.name || item.identifier || '',
        topAddress: '',
        risk: item.level,
        totalTransfers: item.totalCount,
        totalFunds: item.totalAmount / 100,
        riskyFunds: item.totalRisky / 100,
        totalAlerts: item.totalAlerts,
        newAlerts: item?.newAlerts ?? 0,
        ...(extras?.country != null && {
          country: extras.country.code,
        }),
        ...(extras?.isSuspended != null && { isSuspended: extras.isSuspended }),
        ...(extras?.lastActivity != null && {
          lastActivity: extras.lastActivity,
        }),
      };
    });
  }
  return { entries, total };
};

export { fetchCustomers };
